import React from "react";
import { Dropdown } from "react-bootstrap";
import { connect } from "react-redux";
import PageHeader from "../../../components/PageHeader";
import { Link } from "react-router-dom";
import StockCategoriesTable from "../../../components/Tables/StockCategoriesTable";
import {withRouter} from "react-router-dom";
import withPermissions from "../../../components/WithPermissions";
import ManagementPageHero from "../../../components/ManagementPageHero";

class StockCategories extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    const {userPermissions} = this.props;
    const userHasCreatePermission = userPermissions.includes('stock.create');

    return (
      <div
        className="management-page"
        onClick={() => {
          document.body.classList.remove("offcanvas-active");
        }}
      >
        <div>
          <div className="container-fluid">
            <PageHeader
                HeaderText="Ana Kategoriler"
                Breadcrumb={[
                  {name: "Stok Yönetimi", navigate: ""},
                  {name: "Ana Kategoriler", navigate: ""},
                ]}
            />
            <ManagementPageHero
              eyebrow="STOK KATEGORİLERİ"
              title="Stok yapınızı düzenleyin"
              description="Ana ve alt kategorilerle ürünlerinizi düzenli, bulunabilir ve raporlanabilir tutun."
              actionTo={userHasCreatePermission ? "/stock/category-add" : null}
              actionLabel="Yeni ana kategori"
            />
            <div className="row clearfix">
              <div className="col-lg-12 col-md-12">
                <div className="alert alert-info">
                  <strong>📂 Kategori Yönetimi:</strong> Bu sayfada ana kategorileri yönetebilirsiniz. 
                  Alt kategorileri eklemek ve düzenlemek için ana kategorinin detayına gidin.
                </div>
                <div className="card planned_task management-list-card">
                  <div className="header">
                    <h2>Ana Kategoriler</h2>
                    {userHasCreatePermission ? (
                        <Dropdown as="ul" className="header-dropdown">
                          <Dropdown.Toggle
                              variant="success"
                              as="li"
                              id="dropdown-basic"
                          >
                            <i className="icon-plus text-success p-1 ml-1"></i>
                            <Dropdown.Menu
                                as="ul"
                                className="dropdown-menu dropdown-menu-right"
                            >
                              <li>
                                <Link to="/stock/category-add">Yeni Ana Kategori</Link>
                              </li>
                            </Dropdown.Menu>
                          </Dropdown.Toggle>
                        </Dropdown>
                    ) : ""}
                  </div>
                  <div className="body">
                    <StockCategoriesTable />
                  </div>
                </div>
              </div>
            </div>
            <style>
              {`
                #dropdown-basic::after {
                    display: none;                                                     
                }
              `}
            </style>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({stockReducer}) => ({});

export default withPermissions(withRouter(connect(mapStateToProps, {})(StockCategories)));
